import {
    GET_LIST,
    GET_MANY,
    GET_ONE,
    GET_MANY_REFERENCE,
    CREATE,
    UPDATE,
    DELETE
} from 'react-admin';
import { versionsFields } from "./versions.model";
import queryString from 'query-string';
import { getApiUrlForResource } from '../services/apiUrlResolver';
import logger from '../utils/logger';
export const VERSIONS_RESOURCE_NAME = "versions";

// Helper function to get API URL at request time
const getApiUrl = () => getApiUrlForResource(VERSIONS_RESOURCE_NAME);

const providerRequestToHttpRequest = (requestType, requestParams) => {
    switch (requestType) {
        case GET_LIST: 
            // logger.log("Versions ", "Get_List");
            return composeGetVersionsListRequest(requestParams);
        case GET_ONE:
        // logger.log("Versions ", "Get_One");
            return { url: `${getApiUrl()}/${VERSIONS_RESOURCE_NAME}/${requestParams.id}` };
        case GET_MANY: {
            // logger.log("versions_PROVIDER get many with requestParams => ", requestParams);
            const query = {
                filter: JSON.stringify({ id: requestParams.ids }),
            };
            return { url: `${getApiUrl()}/${VERSIONS_RESOURCE_NAME}?${queryString.stringify(query)}` };
        }
        case GET_MANY_REFERENCE: {
            const { page, perPage } = requestParams.pagination;
            const { field, order } = requestParams.sort;
            const query = {
                sort: JSON.stringify([field, order]),
                range: JSON.stringify([(page - 1) * perPage, (page * perPage) - 1]),
                filter: JSON.stringify({ ...requestParams.filter, [requestParams.target]: requestParams.id }),
            };
            return { url: `${getApiUrl()}/${VERSIONS_RESOURCE_NAME}?${queryString.stringify(query)}` };
        }
        case UPDATE:
            return {
                url: `${getApiUrl()}/${VERSIONS_RESOURCE_NAME}/${requestParams.id}`,
                options: { method: 'PUT', body: JSON.stringify(requestParams.data) },
            };
        case CREATE:
            return {
                url: `${getApiUrl()}/${VERSIONS_RESOURCE_NAME}`,
                options: { method: 'POST', body: JSON.stringify(requestParams.data) },
            };
        case DELETE:
            return {
                url: `${getApiUrl()}/${VERSIONS_RESOURCE_NAME}/${requestParams.id}`,
                options: { method: 'DELETE', body: JSON.stringify(requestParams.data) }
            };
        default:
            throw new Error(`Unsupported fetch action type ${requestType}`);
    }
};

const httpResponseToProviderData = (httpResponse, requestType, requestParams) => {
    let { headers, json } = httpResponse;
    switch (requestType) {
        case GET_LIST:
            // Handle V2 response format where data is wrapped in { versions: [...], totalCount: N }
            if (json.versions && json.totalCount !== undefined) {
                return {
                    data: json.versions.map(versionItem => versionItem),
                    total: json.totalCount,
                };
            }
            // Fallback to V1 format
            return {
                data: json.map(versionItem => versionItem),
                total: parseInt(headers.get('content-range').split('/').pop()),
            };
        case GET_MANY:
            let versionIdsToGet = requestParams.ids;
            // logger.log("versions_provider handling ids => ", versionIdsToGet);
            // Handle V2 response format
            const versions = json.versions || json;
            return {
                data: versions.filter(versionItem => versionIdsToGet.includes(versionItem.id))
            };
        case CREATE:
            return { data: { ...requestParams.data, id: json.id } };
        default:
            return { data: json };
    }
};

const composeGetVersionsListRequest = (requestParams) => {
    const { page, perPage } = requestParams.pagination;
    const { field, order } = requestParams.sort;
    let prepareFilters = () => {
        let requestFilters = requestParams.filter;
        if (requestFilters === undefined) {
            return {};
        }
        // logger.log("composeGetVersionsListRequest requestFilters => ", requestFilters);

        let createContainsFilter = (name, value) => ({ name, comparison: "contains", value });
        let createEqFilter = (name, value) => ({ name, comparison: "eq", value });

        let resultFilters = [];
        // append "version" filter
        if (requestFilters.hasOwnProperty(versionsFields.version)) {
            resultFilters.push(createContainsFilter('version', requestFilters[versionsFields.version]));
        }
        
        // append "build" filter
        if (requestFilters.hasOwnProperty(versionsFields.build)) {
            resultFilters.push(createEqFilter('build', requestFilters[versionsFields.build]));
        }
        
        // append "platform" filter
        if (requestFilters.hasOwnProperty(versionsFields.platform)) {
            resultFilters.push(createEqFilter('platform', parseInt(requestFilters[versionsFields.platform])));
        }
        
        // append "app_type" filter
        if (requestFilters.hasOwnProperty(versionsFields.appType)) {
            resultFilters.push(createEqFilter('app_type', parseInt(requestFilters[versionsFields.appType])));
        }
       
        return resultFilters;
    };

    const queryParams = {
        sort: JSON.stringify([field, order]),
        range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
        filters: JSON.stringify(prepareFilters()),
    };
    return { url: `${getApiUrl()}/${VERSIONS_RESOURCE_NAME}?${queryString.stringify(queryParams)}` };
}

export default {
    resource: VERSIONS_RESOURCE_NAME,
    providerInterface: {
        providerRequestToHttpRequest,
        httpResponseToProviderData
    },
};
